import React from 'react';
import PropTypes from  'prop-types';
import { inject, observer } from "mobx-react";
import * as mobx from 'mobx'
import  { withStyles } from  '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import ListSubheader from '@material-ui/core/ListSubheader';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import WifiIcon from '@material-ui/icons/Wifi';
import BluetoothIcon from '@material-ui/icons/Bluetooth';
import Edit from '@material-ui/icons/Edit';
import Email from '@material-ui/icons/Email';
import Link from '@material-ui/icons/Link';
import green from '@material-ui/core/colors/green';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import DestinationDialog from './DestinationDialog'
import FinishDialog from '../Dialogs/FinishDialog'

const shortid = require('shortid')

function isEmpty(obj) {

  if (obj){
    return Object.keys(obj).length === 0 ;
  }
  return true
}


const styles = theme => ({
  root: {
    flexGrow: 1,
    minHeight: 400,
    margin: theme.spacing.unit * 2,
  },
  subheader: {
    marginBottom: theme.spacing.unit * 4,
  },
  card: {
   // marginLeft: theme.spacing.unit * 4,
    marginBottom: theme.spacing.unit,
  },
  cardSelected: {
    marginTop: theme.spacing.unit,
    //marginLeft: theme.spacing.unit * 4,
    marginBottom: theme.spacing.unit,
    backgroundColor: theme.palette.primary.main, //green[500],
    '&:hover': {
      backgroundColor: theme.palette.primary.main,//green[700],
    }
  },
  listRoot: {
    width: '70%',
     backgroundColor: theme.palette.background.paper
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
  button: {
    marginRight: theme.spacing.unit * 3,
  },
  menu: {
    width: 200,
  },
  nested: {
    paddingLeft: theme.spacing.unit,
  },
});

@inject("commonStore")
@inject("authStore")
@observer
class Destinations extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      showForm: false,
      selectedItem: {},
      finishNotify: false,
      filterDeleted: true
    }
  }
  componentDidMount() {
    const { campaign } = this.props.commonStore
    const { destinations } = campaign
    this.setState({checked: destinations})
  }
  getNewDestination = () => {
    console.log('getNewDestination')

    const { agentID } = this.props.commonStore.agent
    const destID = shortid.generate()
    console.log(destID)
    return {agentID, destID}
  }
  handleCloseForm = (values) => {
    const { destinations } = this.props
   

    console.log('handleCloseForm')
      console.log(values)
    if (!(isEmpty(values))){
      const { status, destID } = values
      this.props.authStore.updateDestination(values)
      if(status === 'deleted'){
        if(destinations.includes(destID)){
          this.handleToggleStatus(destID)
        }
      }
    }
    this.setState({ showForm: false })
  }

  showDestinationDetail = (destination) => {
    console.log('showDestinationDetail')
    console.log(destination)
    console.log(destination)

      if(!destination){
        const newDest = this.getNewDestination()
        console.log(newDest)
        
        this.setState({ showForm: true, selectedItem: newDest })
        
      }else{
        this.setState({ showForm: true, selectedItem: destination })
      }
  }
  handleToggleStatus = (value) => {
    const { destinations, handleUpdate } = this.props
    const checked = [...destinations]

    console.log('handleToggleStatus')

    console.log(checked)

    const currentIndex = checked.indexOf(value);


    if (currentIndex === -1) {
      checked.push(value);
    } else {
      checked.splice(currentIndex, 1);
    }

    console.log(checked)

    handleUpdate('destinations', checked)
    this.setState({finishNotify: true})

  };
  makeListItems = () => {
    const { filterDeleted } = this.state 
    const { classes, destinations, commonStore } = this.props
    const { allDestinations } = commonStore
    const checked = [...destinations]
    let count = 0
    let filteredDestinations = [...allDestinations]
    if(filterDeleted){
      filteredDestinations = allDestinations.filter((item) => {
        return item.status !== 'deleted'
      })
    }
    
  
    const itemsArray = filteredDestinations.map(item => {

      const { destID, destinationType } = item

      count = count + 1;
    
      const checkedIndex = checked.indexOf(destID);

      console.log(checkedIndex)

      let isSelected = false
      if(checkedIndex > -1){
        isSelected = true
      }

      console.log(isSelected)

      const indexName = `index${count}`;
          return (
            <Card key={count} className={isSelected ? classes.cardSelected : classes.card }>
            <CardContent>
                <ListItem className={classes.nested}>
                <Switch
                onChange={() => this.handleToggleStatus(item.destID)}
                checked={checked.indexOf(destID) !== -1}
              />
                <ListItemIcon>
                {destinationType === 'email' ?  <Email color={isSelected ? "secondary" : "primary"}/> : <Link color={isSelected ? "secondary" : "primary"} />}
                </ListItemIcon>
                {isSelected ?  <Typography color='secondary' ><ListItemText disableTypography secondary={item.destination}/> </Typography>: <ListItemText primary={item.destination} /> }
                <ListItemSecondaryAction>
                  <Button onClick={() => {this.showDestinationDetail(item)}}>
                  <Edit color="secondary"/>
                  </Button>
              </ListItemSecondaryAction>
              </ListItem>
              </CardContent>
              </Card>
          )
    })
    return itemsArray
  }
  render() {
    const { showForm, finishNotify, selectedItem, filterDeleted} = this.state
    const { classes, open, commonStore, campaignID } = this.props
    const { destinationAttributes } = commonStore

    console.log('selectedItem render')
    console.log(selectedItem)
  
   return (
    <div className={classes.root}>
    <List
    component="nav"
    subheader={<ListSubheader className={classes.subheader} component="div">
    <Button variant="contained" color="primary" onClick={() => {this.showDestinationDetail()}}>Add New</Button>
    <Typography color={'inherit'} component="p">
      Where would you like your leads to be delivered for this campaign? </Typography>
      <Typography color={'inherit'} component="p">  Be sure to turn on your campaign (button on the left) to get added to the queue and to start receiving leads.</Typography>
      <FormControlLabel
      control={
        <Switch
          checked={filterDeleted}
          onChange={() => {this.setState({filterDeleted:!filterDeleted})}}
        />
      }
      label="Show Deleted Destinations"
    />
     </ListSubheader>}
  >
  {this.makeListItems()}
  </List>
    {showForm ? <DestinationDialog {...selectedItem} open={true} handleClose={this.handleCloseForm} destinationAttributes={destinationAttributes}/> : null }
    {campaignID  ? <FinishDialog open={finishNotify} close={() => {this.setState({finishNotify: false})}} /> : null}
    </div>
  );

  }
}

Destinations.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Destinations);


// WEBPACK FOOTER //
// ./src/components/Leads/Campaigns/ManageCampaign/Options/Destinations/index.js